import React from 'react';

import "./LinkBlank.scss";
import { Link } from '@randajan/jet-react/dom/link';

export const LinkBlank = (props)=><Link {...props} target="_blank"/>;

